var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragedrop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.125,
    cy: 11.525,
    r: 1.375,
    transform: "rotate(-180 7.125 11.525)",
    fill: "#67768E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.125,
    cy: 6.775,
    r: 1.375,
    transform: "rotate(-180 7.125 6.775)",
    fill: "#67768E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.125,
    cy: 2.025,
    r: 1.375,
    transform: "rotate(-180 7.125 2.025)",
    fill: "#67768E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.125,
    cy: 11.525,
    r: 1.375,
    transform: "rotate(-180 2.125 11.525)",
    fill: "#67768E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.125,
    cy: 6.775,
    r: 1.375,
    transform: "rotate(-180 2.125 6.775)",
    fill: "#67768E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.125,
    cy: 2.025,
    r: 1.375,
    transform: "rotate(-180 2.125 2.025)",
    fill: "#67768E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragedrop);
export default __webpack_public_path__ + "static/media/dragedrop.d1d4ca1ce41ead3aaa0b9005f6a553b1.svg";
export { ForwardRef as ReactComponent };